function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { cloneElement, createRef } from 'react';
import { array, bool, string, oneOfType, element, number, object, func } from 'prop-types';
import classnames from 'classnames';
import Input from "semantic-ui-react/dist/es/elements/Input/Input.js";
import { some } from "../../../utils/some";
import { returnFirstArgument } from "../../../utils/return-first-argument";
import { ErrorMessage } from "../ErrorMessage";
import { getValueFromEvent } from "./utils/getValueFromEvent";
var ICON_POSITION = 'left';
export var Component = function Component(_ref) {
  var _objectSpread2;

  var adaptOnChangeEvent = _ref.adaptOnChangeEvent,
      children = _ref.children,
      error = _ref.error,
      icon = _ref.icon,
      inputOnChangeFunctionName = _ref.inputOnChangeFunctionName,
      isCompact = _ref.isCompact,
      isFocused = _ref.isFocused,
      isFluid = _ref.isFluid,
      isValid = _ref.isValid,
      mapValueToProps = _ref.mapValueToProps,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value;
  var showError = !!error && typeof error === 'string';
  var inputRef = createRef();

  var handleChange = function handleChange() {
    onChange(name, adaptOnChangeEvent.apply(void 0, arguments));
  };

  return React.createElement(Input, {
    className: classnames({
      dirty: some(value),
      compact: isCompact,
      error: !!error,
      focus: isFocused,
      valid: isValid
    }),
    fluid: isFluid,
    iconPosition: icon && ICON_POSITION,
    name: name,
    value: value
  }, cloneElement(children, _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, inputOnChangeFunctionName, handleChange), _defineProperty(_objectSpread2, "ref", inputRef), _objectSpread2), mapValueToProps(value))), showError && React.createElement(ErrorMessage, {
    errorMessage: error
  }), icon);
};
Component.displayName = 'InputController';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  adaptOnChangeEvent: func,
  children: element.isRequired,
  error: oneOfType([bool, string]),
  icon: element,
  inputOnChangeFunctionName: string,
  isCompact: bool,
  isFluid: bool,
  isFocused: bool,
  isValid: bool,
  mapValueToProps: func,
  name: string.isRequired,
  onChange: func,
  value: oneOfType([bool, string, number, object, array])
} : {};
Component.defaultProps = {
  adaptOnChangeEvent: getValueFromEvent,
  inputOnChangeFunctionName: 'onChange',
  isCompact: false,
  isValid: false,
  isFocused: false,
  error: false,
  isFluid: false,
  icon: null,
  onChange: returnFirstArgument,
  value: null,
  mapValueToProps: function mapValueToProps(value) {
    return {
      value: value
    };
  }
};